import type { RequestPolicy, RequestPolicyFactory, RequestPolicyOptions } from '@azure/ms-rest-js';

import { Config } from '../../helpers/Config';
import { CustomHeaderPolicy } from './CustomHeaderPolicy';

export const tenantPolicy = (): RequestPolicyFactory => {
  const headerKey = 'x-tenant-context';

  return {
    create: (nextPolicy: RequestPolicy, options: RequestPolicyOptions): CustomHeaderPolicy => {
      const { tenant } = Config.get();

      return new CustomHeaderPolicy(nextPolicy, options, headerKey, tenant);
    },
  };
};
